// utils/shopHref.ts
import { compactSlug } from "utils/slug";

type ShopLike = {
  id: string | number;
  name?: string;
  translation?: { title?: string };
};

export function shopHref(s: ShopLike) {
  const title = s?.translation?.title || s?.name || "";
  return `/shop/${s.id}/${compactSlug(title)}`;
}